import * as PIXI from 'pixi.js'
import { GameConfig } from './game';
import { Sticker } from '../generator/sticker';

export default class Korony extends PIXI.Application {
    private baseWidth: number;
    private baseHeight: number;
    private baseRatio: number;
    private scaleRatio = 1;
    private resources?: Partial<Record<string, PIXI.LoaderResource>>;

    constructor(width: number, height: number, backgroundColor: number, private config: GameConfig) {
        super({
            width,
            height,
            backgroundColor
        });

        this.baseHeight = height;
        this.baseWidth = width;
        this.baseRatio = height / width;

        window.addEventListener('resize', this.gameResize)

        this.loadTextures().then((resources) => {
            this.resources = resources;
            this.initGame()
        })
    }

    private loadTextures(): Promise<Partial<Record<string, PIXI.LoaderResource>>> {
        return new Promise((resolve) => {
            [
                ['macius', '/tasks/402/macius.png'],
                ['k1', '/tasks/402/1.png'],
                ['k2', '/tasks/402/2.png'],
                ['k3', '/tasks/402/3.png'],
                ['k4', '/tasks/402/4.png'],
                ['k5', '/tasks/402/5.png'],
                ['k6', '/tasks/402/6.png']
            ].forEach(([key, src]) => {
                this.loader.add(key, src);
            })

            this.loader.load((loader, resource) => {
                resolve(resource)
            })

            this.loader.onError.add((...args: any[]) => {
                console.error(...args);
            })
        })

    }

    private initGame() {
        this.initMacius();
        this.initStickers();
    }

    private initMacius() {
        if (this.resources?.macius) {
            const macius = new PIXI.Sprite(this.resources.macius.texture)

            macius.anchor.set(.5, 1);

            macius.x = this.baseWidth/2;
            macius.y = this.baseHeight;

            this.stage.addChild(macius);
        }
    }

    private initStickers() {
        if (this.resources) {
        const k = ['k1', 'k2', 'k3', 'k4', 'k5', 'k6'].map(key => {
                const sticker = new Sticker(
                    //@ts-ignore
                    this.resources[key].texture,
                    100, 100,
                    key
                )

                sticker.scale.set(270 / sticker.width)

                this.stage.addChild(sticker);

                return sticker
            })

            k[0]?.position.set(1000,100)
            k[1]?.position.set(300,150)
            k[2]?.position.set(650,100)
            k[3]?.position.set(1000,500)
            k[4]?.position.set(300,400)
            k[5]?.position.set(1000,300)
        }
    }

    public gameResize = () => {
        const nW = this.config.container.offsetWidth;
        const nH = nW * this.baseRatio;

        this.renderer.resize(nW, nH);

        this.scaleRatio = (nW / this.baseWidth);

        this.stage.scale.set(this.scaleRatio)
    }

    public getSceenBlob() {
            const data = this.renderer.extract.canvas(this.stage).toDataURL('image/png', 1);
            return data;
    }
}
